import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import css from "./breadcrumbs.module.scss";

type BreadCrumbsProps = {
  currentName: string;
};

const BreadCrumbs = ({ currentName }: BreadCrumbsProps) => {
  const { t } = useTranslation("bookingModule");

  return (
    <div className={css.root}>
      <Link to="/admin/booking/calendars">{t("config.calendars.linkToAll")}</Link>
      <span className={css.chevron}>{">"}</span>
      {currentName}
    </div>
  );
};

export default BreadCrumbs;
